import BrandLibrary from '@enreach/brand-library-enreach/web/esm';

const brandLibrary = new BrandLibrary();

export default brandLibrary;
